import React from 'react';
import { Row, Col } from 'react-bootstrap';

import InfoRow from 'components/common/InfoRow';
import SubtleBadge from 'components/common/SubtleBadge';

import { formatValue } from 'utils/valueFormatters';

const ManageProductViewMode = ({ product }) => {
  return (
    <Row>
      <Col md={6}>
        <InfoRow label="Product Name" value={formatValue(product?.name)} />
        <InfoRow label="Barcode" value={formatValue(product?.barcode)} />
        <InfoRow
          label="MRP Amount"
          value={formatValue(product?.mrp?.amount, '-', {
            isNumber: true,
          })}
        />
        <InfoRow label="HSN Code" value={formatValue(product?.hsn_code)} />
        <InfoRow
          label="Tax"
          value={
            product?.tax_type
              ? `${product.tax_type.name} (${product.tax_type.tax_rate}%)`
              : '-'
          }
        />
      </Col>

      <Col md={6}>
        <InfoRow label="Scan Type" value={formatValue(product?.scan_type)} />
        <InfoRow
          label="Status"
          value={
            <SubtleBadge
              bg={product?.is_active ? 'success' : 'secondary'}
              className="fs-11"
            >
              {product?.is_active ? 'Active' : 'Inactive'}
            </SubtleBadge>
          }
        />
        <InfoRow
          label="Size"
          value={`Width(mm): ${formatValue(product?.width, '-', {
            isNumber: true,
            decimals: 2,
          })}, Height(mm): ${formatValue(product?.height, '-', {
            isNumber: true,
            decimals: 2,
          })}, Length(mm): ${formatValue(product?.length, '-', {
            isNumber: true,
            decimals: 2,
          })}`}
        />
        <InfoRow
          label="Weight"
          value={
            product?.weight
              ? `${formatValue(product?.weight?.value, '-', {
                  isNumber: true,
                  decimals: 2,
                })} ${product?.weight?.unit}`
              : '-'
          }
        />
      </Col>
    </Row>
  );
};

export default ManageProductViewMode;
